<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form>
      <v-card-text>
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiChartTimelineVariant }}
          </v-icon>
          <span>Notificações</span>
        </v-card-title>

        <!-- Activity -->

        <v-switch
          hide-details
          class="mt-4"
        >
          <template #label>
            <span class="text-sm ms-2">Receber notificações por SMS?</span>
          </template>
        </v-switch>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          :to="{ name: 'colaboradores' }"
        >
          Salvar alterações
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="ml-2 mb-2 me-3 mt-4"
          disabled
          :to="{ name: 'colaboradores' }"
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mb-2 mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
import { mdiChartTimelineVariant, mdiEmailOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  props: {
    notificationData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  setup(props) {
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.notificationData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.notificationData))
    }

    return {
      icons: { mdiChartTimelineVariant, mdiEmailOutline },
      resetForm,
      accountDataLocale,
    }
  },
}
</script>
